import { render } from "./CampaignMenu.vue?vue&type=template&id=7122f201&scoped=true"
import script from "./CampaignMenu.vue?vue&type=script&lang=js"
export * from "./CampaignMenu.vue?vue&type=script&lang=js"

import "./CampaignMenu.vue?vue&type=style&index=0&id=7122f201&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7122f201"]])

export default __exports__